import type { AxiosError } from 'axios';
import type { DocumentPickerAsset } from 'expo-document-picker';
import type { ImagePickerAsset } from 'expo-image-picker';
import { Platform } from 'react-native';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';
import type { Reservation } from '@/api/reservations';

export type ChargingRecordSubmission = {
  chargingStationName: string;
  entryDate: string;
  amount: number;
};

type Variables = {
  id: number;
  chargingRecords: ChargingRecordSubmission[];
  images: ImagePickerAsset[] | DocumentPickerAsset[];
};
export type CreateChargingRecordsResponse = {
  data: Reservation;
};

export const useCreateChargingRecords = createMutation<
  CreateChargingRecordsResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) => {
    const formData = new FormData();

    variables.chargingRecords.forEach((chargingRecord, index) => {
      formData.append(
        `charging_records[${index}][location]`,
        chargingRecord.chargingStationName
      );
      formData.append(
        `charging_records[${index}][start_timestamp]`,
        chargingRecord.entryDate
      );
      formData.append(
        `charging_records[${index}][amount]`,
        chargingRecord.amount.toString()
      );
    });

    variables.images.forEach(
      (image: ImagePickerAsset | DocumentPickerAsset) => {
        if (Platform.OS === 'web') {
          formData.append('images[]', image); // Append the file object directly for web
        } else {
          formData.append('images[]', {
            uri: image.uri,
            name: image.fileName || image.name,
            type: image.mimeType || 'image/jpeg',
          });
        }
      }
    );

    return client({
      url: `v2/internal/partners/reservations/${variables.id}/charging-records`,
      method: 'POST',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        console.error('yoyo', err);
        throw new Error(err.response.data.errors.join(', '));
      });
  },
});
